// Validation utilities for zenky-deploy dashboard

/**
 * Validates UUID format (RFC 4122)
 * @param value - The string to validate as UUID
 * @returns Error message string if invalid, undefined if valid
 */
export const validateUUID = (value: string): string | undefined => {
  // Check if empty
  if (!value || value.trim() === '') {
    return 'Required field';
  }

  // UUID regex pattern (RFC 4122: 8-4-4-4-12 hexadecimal format)
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  if (!uuidRegex.test(value)) {
    return 'Invalid UUID format';
  }

  return undefined;
};
